const debounce = 250;

/**
 * Add Javascript Support for Back To Top button
 * @returns {undefined} Returns nothing
*/

export default function bindBackToTopSupport(component) {
    const $backToTopButton = $('.js-back-to-top');

    if($backToTopButton.length) {
        const scrollHeightMultiplier = _.get(component.getDeviceCharacteristics(), 'is_medium') ? 2.5 : 3;
        const scrollPositionThreshold = $(window).height() * scrollHeightMultiplier;

        $(window).scroll(_.debounce(() => {
            $backToTopButton.toggleClass('is-shown', $(window).scrollTop() > scrollPositionThreshold );
        }, debounce));

        $(document).on('click', '.js-back-to-top', (e) => {
            e.preventDefault();
            e.stopPropagation();
            $('html, body').animate({
                scrollTop: 0
            }, 100);
        });

    }
}
